import AdsModel, { AdsFilter } from "../models/ads.model";
import { AdType } from "../types/ad"
import { useReducerAsState } from "./useReducerAsState"

interface State {
    ads: Array<AdType>;
    ad: AdType | null;
    loading: boolean;
    error: string;
    totalAds: number;
}

const useAds = () => {
    const [state, setState] = useReducerAsState<State>({
        ads: [],
        ad: null,
        loading: false,
        error: "",
        totalAds: 0
    });

    const { ads, ad, totalAds, loading, error } = state

    const fetchAds = async (filters: AdsFilter) => {
        setState({error: "", loading: true})
        const response = await AdsModel.getAll(filters)
        if(response.error){
            setState({error: response.error, loading: false, ads: [], totalAds: 0})
            return
        }

        setState({error: "", loading: false, ads: response.ads?.data, totalAds: response.total})
    }

    const findAd = async (itemId: number) => {
        setState({error: "", loading: true})
        const response = await AdsModel.find(itemId)
        if(response.error){
            setState({error: response.error, loading: false, ad: null})
            return
        }

        setState({error: "", loading: false, ad: response.ads?.data[0]})
    }

    const saveAd = async (item: AdType) => {
        setState({error: "", loading: true})
        const response = await AdsModel.saveAd(item)
        if(response.error){
            setState({error: response.error, loading: false})
            return false
        }

        setState({error: "", loading: false})
        return true
    }

    const deleteAd = async (itemId: number): Promise<boolean> => {
        setState({error: "", loading: true})
        const response = await AdsModel.delete(itemId)
        if(response.error){
            setState({error: response.error, loading: false})
            return false
        }

        setState({error: "", loading: false})
        return true
    }

    return {
        ads,
        ad,
        loading,
        error,
        totalAds,
        fetchAds,
        findAd,
        saveAd,
        deleteAd
    }
}

export default useAds